import React from 'react'
import { iWebFormField } from '../schema'
import { Box } from '@mui/material'

const HeaderContent = ({idNamespace, fieldConfig}: {idNamespace?:string, fieldConfig:iWebFormField}) => {
    const {fieldLabel,fieldDescription}=fieldConfig;
    return (
        <Box id={idNamespace ? `${idNamespace}-${fieldConfig.id}` : undefined}>
            <p style={{fontSize:'16px'}}><b>{fieldLabel}</b> : {fieldDescription}</p>
        </Box>
    )
}

export default HeaderContent